/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * DSV Public API
 * DSV Public API
 * OpenAPI spec version: 1.2.3
 */

export type EventRegistrationContactType = typeof EventRegistrationContactType[keyof typeof EventRegistrationContactType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EventRegistrationContactType = {
  PARENT: 'PARENT',
  GRAND_PARENT: 'GRAND_PARENT',
  RELATIVE: 'RELATIVE',
  WELL_KNOWN: 'WELL_KNOWN',
  PARTNER: 'PARTNER',
} as const;
